export const LOGO_LIGHT = "/api/files/sbs-properties/uploads/17902f68-7668-4fa5-9339-1cf504cd96d6.png";
export const LOGO_DARK = "/api/files/sbs-properties/uploads/95979bfb-c346-47e0-8227-240646b55293.png";

export const SOCIALS = [
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/sbs.properties.llc/", color: "#E4405F" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/sbs.properties.llc/", color: "#1877F2" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/company/sbsproperties", color: "#0A66C2" },
];

export const CITIES = ["Mombasa", "Nyali", "Bamburi", "Shanzu", "Mtwapa", "Kikambala", "Vipingo", "Kilifi", "Watamu", "Malindi", "Mambrui", "Lamu", "Ukunda", "Diani", "Msambweni", "Shimoni", "Voi", "Dar es Salaam", "Zanzibar City", "Tanga", "Bagamoyo"];
